/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RateFetchSummary
 */
export interface RateFetchSummary {
    /**
     * 
     * @type {string}
     * @memberof RateFetchSummary
     */
    supplier?: string;
    /**
     * 
     * @type {number}
     * @memberof RateFetchSummary
     */
    totalFetches24h?: number;
    /**
     * 
     * @type {Date}
     * @memberof RateFetchSummary
     */
    latestFetchAt?: Date;
}

/**
 * Check if a given object implements the RateFetchSummary interface.
 */
export function instanceOfRateFetchSummary(value: object): value is RateFetchSummary {
    return true;
}

export function RateFetchSummaryFromJSON(json: any): RateFetchSummary {
    return RateFetchSummaryFromJSONTyped(json, false);
}

export function RateFetchSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): RateFetchSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'supplier': json['supplier'] == null ? undefined : json['supplier'],
        'totalFetches24h': json['total_fetches_24h'] == null ? undefined : json['total_fetches_24h'],
        'latestFetchAt': json['latest_fetch_at'] == null ? undefined : (new Date(json['latest_fetch_at'])),
    };
}

export function RateFetchSummaryToJSON(json: any): RateFetchSummary {
    return RateFetchSummaryToJSONTyped(json, false);
}

export function RateFetchSummaryToJSONTyped(value?: RateFetchSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'supplier': value['supplier'],
        'total_fetches_24h': value['totalFetches24h'],
        'latest_fetch_at': value['latestFetchAt'] == null ? value['latestFetchAt'] : value['latestFetchAt'].toISOString(),
    };
}

